import { NGXLogger } from 'ngx-logger';
import { Component } from '@angular/core';
import { Input, HostBinding } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';


/**
 * Allows a string to be wrapped to distinguish
 * a code to be localized from the message text.
 */
export class MessageCode {
  constructor(public code: string) {}
}

export class Message {
  title?: string;
  text?: string|SafeHtml;
  field?: string;
  dismissible: boolean;
  autoHide: number;
  elementId?: string; // used on some pages
  type?: string; // error, warning, info, success.

  constructor(title?: string, text?: string|SafeHtml) {
    if (title) {
      this.title = title;
    }
    if (text) {
      this.text = text;
    }
    this.dismissible = true;
    this.autoHide = 0;
  }
}

@Component({
  selector: 'iui-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class IuiMessagesComponent {

  @Input() public autohide = 0;

  @HostBinding('class') klass: string;

  @Input() styleClass?: string;

  public errors: Message[] = [];
  public warnings: Message[] = [];
  public infos: Message[] = [];
  public successes: Message[] = [];

  showingAll = false;

  constructor(private logger: NGXLogger) {
    this.clearAll();
    this.klass = 'iuimessages mx-auto';
  }

  clearAll() {
    this.errors = [];
    this.infos = [];
    this.warnings = [];
    this.successes = [];
  }

  clearSuccessMessages() {
    this.successes = [];
  }

  hasMessages(): boolean {
    const rv = this.errors.length + this.infos.length +
      this.successes.length + this.warnings.length !== 0;
    return rv;
  }

  clearErrors() {
    this.errors = [];
  }

  private startAutoHide(msg: Message): Promise<void> {
    return new Promise((resolve) => {
      if (this.autohide !== 0) {
        setTimeout(() => {
          resolve();
        },
          this.autohide);
      }
      if (msg.autoHide !== 0) {
        setTimeout(() => {
          resolve();
        },
          msg.autoHide);
      }
    });
  }

  dismiss(group: string, item?: Message) {
    let grp: Message[] | undefined;
    switch (group) {
      case 'success': grp = this.successes; break;
      case 'info': grp = this.infos; break;
      case 'warning': grp = this.warnings; break;
      case 'error': grp = this.errors; break;
    }
    if (grp) {
      if (item) {
        const idx = grp.indexOf(item);
        if (idx >= 0) {
          grp.splice(idx, 1);
        }
        else {
          this.logger.warn('item ' + item + ' not found in group');
        }
      }
      else {
        switch (group) {
          case 'success': this.successes = []; break;
          case 'info': this.infos = []; break;
          case 'warning': this.warnings = []; break;
          case 'error': this.errors = []; break;
        }
      }
    }
    else {
      this.logger.warn('bad group ' + group);
    }
  }

  removeFromArray(a: Message[], i: Message) {
    const idx = a.indexOf(i);
    if (idx >= 0) {
      a.splice(idx, 1);
    }
  }

  displaySuccess(msg: Message) {
    this.successes.push(msg);
    this.startAutoHide(msg).then(() => this.removeFromArray(this.successes, msg));
  }
  displayError(msg: Message) {
    this.errors.push(msg);
    this.startAutoHide(msg).then(() => { this.removeFromArray(this.errors, msg); });
  }
  displayWarning(msg: Message) {
    this.warnings.push(msg);
    this.startAutoHide(msg).then(() => { this.removeFromArray(this.warnings, msg); });
  }
  displayInfo(msg: Message) {
    this.infos.push(msg);
    this.startAutoHide(msg).then(() => { this.removeFromArray(this.infos, msg); });
  }
}
